export default __webpack_public_path__ + "static/media/create-review-benchmark-header.98592698.svg";